import { render, staticRenderFns } from "./TwProcessGroupListPreviewIpDnItem.vue?vue&type=template&id=50983630&scoped=true&"
import script from "./TwProcessGroupListPreviewIpDnItem.vue?vue&type=script&lang=js&"
export * from "./TwProcessGroupListPreviewIpDnItem.vue?vue&type=script&lang=js&"
import style0 from "./TwProcessGroupListPreviewIpDnItem.vue?vue&type=style&index=0&id=50983630&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50983630",
  null
  
)

export default component.exports